<!-- Card -->
<section class="card">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'surveyModule.sendASurvey' | translate }}
    </h3>
  </div>
  <!-- End Header -->
  <!-- Body -->
  <div class="card-body">
    <ng-template #isLoadingSpinner>
      <div
        class="spinner-border my-5 mx-auto d-block"
        role="status"
        attr.aria-label="{{ 'general.loading' | translate }}"
      >
      </div>
    </ng-template>
    <form [formGroup]="form" (ngSubmit)="onFormSubmit()">
      <div class="mb-4">
        <label class="form-label">
          {{ 'productModule.selectSurvey' | translate }}</label
        >

        <survey-select-input
          (search)="onSearchSurveys($event)"
          [surveys]="surveys$ | async"
          formControlName="surveyId"
          [allowClearing]="false"
        ></survey-select-input>

        <!-- <select
            formControlName="surveyId"
            class="form-select"
            [attr.aria-invalid]="form.controls.surveyId.dirty && form.controls.surveyId.invalid ? 'true' : null"          >
            <option
              *ngFor="let survey of surveys$ | async"
              [ngValue]="survey.id"
            >
              {{ survey.name }}
            </option>
          </select> -->
      </div>

      <div class="form-footer" [canSee]="accessRights.Sales_write">
        <button class="btn btn-primary" [disabled]="!form.dirty" type="submit">
          {{ 'general.send' | translate }}
        </button>
      </div>
    </form>
    <!-- End Body -->
  </div>
  <!-- End Card -->
</section>
